import React, {useEffect} from 'react';
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import {formatCurrency, formatPL, isMobile} from '../../../utils/commonMethods';
import RupeeVal from '../../../commonComponents/RupeeVal';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {useGetValue} from './useGetValue';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';

const PortfolioSummary = ({isLiveChecked, closedHeader, data1}) => {
  const data = useGetValue(data1?.probes, closedHeader);

  const totalInvestment = () => {
    let totalInvestedAmount = 0;
    if (isLiveChecked) {
      const Investment = data?.probes?.map(
        probe =>
          (probe?.probe_type !== 'promo' && probe?.summary?.[0]?.value) ??
          probe?.current_value,
      );
      for (let i = 0; i < Investment?.length; i++) {
        totalInvestedAmount += isNaN(Investment?.[i]?.[0])
          ? // ? parseFloat(Investment?.[i]?.slice(1))
            0
          : parseFloat(Investment?.[i]);
      }
    } else {
      if (closedHeader?.total_invested) {
        totalInvestedAmount = closedHeader?.total_invested;
      }
    }

    return totalInvestedAmount.toFixed(2);
  };

  const totalOpenOrderValue = () => {
    let openOrderValue = 0;
    if (isLiveChecked) {
      const Investment = data?.probes?.map(
        probe =>
          (probe?.probe_type !== 'promo' &&
            probe?.summary &&
            probe?.summary?.[4]?.value) ??
          probe.current_value,
      );

      for (let i = 0; i < Investment?.length; i++) {
        openOrderValue += Investment[i];
      }
    } else {
      if (closedHeader?.total_invested) {
        openOrderValue = closedHeader?.total_invested;
      }
    }

    return openOrderValue.toFixed(2);
  };

  const totalCurrentValue = () => {
    let totalCurrentAmount = 0;
    let currentNull = false;

    const current = data?.probes?.map(probe => {
      if (
        probe?.probe_type !== 'promo' &&
        probe?.summary &&
        probe?.summary?.[3]?.value
      ) {
        currentNull = true;
      }
      return (
        probe?.probe_type !== 'promo' &&
        probe?.summary &&
        probe?.summary?.[1]?.value
      );
    });
    if (current) {
      for (let i = 0; i < current?.length; i++) {
        totalCurrentAmount += isNaN(current?.[i]?.[0])
          ? // ? parseFloat(current?.[i]?.slice(1))
            0
          : parseFloat(current?.[i]);
      }
    }
    // return totalCurrentAmount;
    return totalCurrentAmount <= 0 && currentNull
      ? null
      : totalCurrentAmount.toFixed(2);
  };
  const totalPayout = () => {
    let totalPayoutAmount = 0;
    /*const Payout = closedMarketDetails?.historyRows?.map(
      (probe) => probe.totalreturn
    );
    for (let i = 0; i < Payout?.length; i++) {
      totalPayoutAmount += parseFloat(Payout[i]);
    }*/
    if (closedHeader?.total_return) {
      totalPayoutAmount = closedHeader?.total_return;
    }
    return totalPayoutAmount.toFixed(2);
  };

  const ProfitLossPercentage = (
    (((isLiveChecked ? totalCurrentValue() : totalPayout()) -
      totalInvestment()) *
      100) /
    totalInvestment()
  ).toFixed(1);

  const isProfit = ProfitLossPercentage <= 0 ? false : true;
  const TotalMarkets = isLiveChecked
    ? data?.probes?.length
    : closedHeader?.total_events || 0;

  return (
    <>
      <View style={styles.portfolioSummaryBox}>
        <View
          style={[
            styles.walletContainer,
            isMobile() ? {borderBottomWidth: 0.75} : {borderRightWidth: 0.75},
          ]}>
          <View>
            <View>
              <FormTextLabel
                labelStyles={styles.creditAvaialableTxt}
                label={isLiveChecked ? 'Current Value' : 'Total Payout'}
              />
              {(TotalMarkets && totalCurrentValue() !== null) ||
              (TotalMarkets && !isLiveChecked) ? (
                <View style={{flexDirection: 'row'}}>
                  <Text style={styles.creditsAmt}>
                    {formatCurrency(
                      isLiveChecked ? totalCurrentValue() : totalPayout(),
                    )}
                    <Text
                      style={[
                        {...globalFontStyle.appFontHeadingRegular},
                        isProfit
                          ? {color: globalConfigurableData.profitColor}
                          : {color: globalConfigurableData.lossColor},
                      ]}>
                      &nbsp;{' ( ' + formatPL(ProfitLossPercentage) + ')'}
                    </Text>
                  </Text>
                </View>
              ) : (
                <Text style={styles.creditsAmt}>--</Text>
              )}
            </View>
          </View>
        </View>
        <View style={[styles.walletContainer]}>
          <View>
            <View>
              <FormTextLabel
                labelStyles={styles.creditAvaialableTxt}
                label={
                  isLiveChecked ? ' Open Orders Value' : 'Total Investment'
                }
              />
              <Text style={styles.creditsAmt}>
                {' '}
                {formatCurrency(TotalMarkets ? totalOpenOrderValue() : '--')}
              </Text>
            </View>
          </View>
        </View>
      </View>
      {/*<View style={{marginTop: 20, marginBottom: 5, flexDirection: 'row', alignItems: 'center'}}>*/}
      {/*  {isMobile() && (<View style={{height: 40, backgroundColor: Colors.tradexBlue, width: 6, position: 'absolute', left: -17 }} />)}*/}
      {/*  <Text style={{...globalFontStyle.appFontHeading,*/}
      {/*    color: Colors.black}}>*/}
      {/*    {isLiveChecked ? " Open Positions" : "Closed Positions"}</Text>*/}
      {/*  <View style={{ width: 6, height: 6, borderRadius: 100, backgroundColor: '#D9D9D9', marginHorizontal: 8}}/>*/}
      {/*  <Text style={{...globalFontStyle.appFontHeading,*/}
      {/*    color: Colors.tradexBlue}}>*/}
      {/*    {TotalMarkets}</Text>*/}
      {/*</View>*/}
    </>
  );
};

export default PortfolioSummary;

const styles = StyleSheet.create({
  portfolioSummaryBox: {
    // borderRadius: 10,
    marginTop: 20,
    borderWidth: 0.75,
    borderColor: GlobalScreens.Portfolio.borderColor,
    borderRadius: 8,
    flexDirection: isMobile() ? 'column' : 'row',
    marginBottom: 10,
    backgroundColor: GlobalScreens.Portfolio.cardBgColor,
  },
  walletContainer: {
    paddingVertical: 15,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderColor: GlobalScreens.Portfolio.borderColor,
    flex: 1,
  },
  creditAvaialableTxt: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
    paddingBottom: isMobile() ? 5 : 8,
  },
  creditsAmt: {
    ...globalFontStyle.appFontTitle,
    color: globalConfigurableData.primaryTextColor1,
  },
});
